export default '/build/66575a55.jpg'